import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeExitClearanceDto } from 'src/app/models/EmployeeExitClearanceDto';
import { ExitClearanceApprovalDto } from 'src/app/models/ExitClearanceApprovalDto';
import { PendingExitApprovalModel } from 'src/app/models/PendingExitApprovalModel';
import { approveMovementVm } from 'src/app/models/approveMovementVm';
import { NotificationType } from 'src/app/models/notification.message';
import { ExitClearanceService } from 'src/app/services/exit-clearance.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';


@Component({
  selector: 'app-exit-clearance-forms',
  templateUrl: './exit-clearance-forms.component.html',
  styleUrls: ['./exit-clearance-forms.component.css']
})
export class ExitClearanceFormsComponent implements OnInit {

  currentUser: any;
  email: any;
  Requests: PendingExitApprovalModel[] = [];
  isPendingpprovalModalVisible = false;
  ExitRequest: EmployeeExitClearanceDto  |null =null;
  isCancelVisible:boolean=false;
  ExitRequestApprovals: ExitClearanceApprovalDto[] | undefined;
  MyPendingExitRequestApprovals: ExitClearanceApprovalDto[] | undefined;
  ViewExitRequestVisible = false;
  canPrint: boolean = false;

  isRetractModalVisible = false;
  retractReason: string = '';
  selectedId: number = 0;

  constructor( private notification: NotificationService,  private router: Router, public datepipe: DatePipe,
    private userService: UserService, private exitClearanceService:ExitClearanceService, private tokenService: TokenService) 
  {



   }

  ngOnInit(): void {
      
   this. loadRecords();
  }

  handleCancel(): void {
    this.isPendingpprovalModalVisible = false;
    this.isCancelVisible = false;
    
  }

  getStatusColor(status: string): string { 
    switch (status) {
      case "New":
        return 'badge badge-warning';
      case "Pending":
        return 'badge badge-warning';
      case "Approved":
        return 'badge badge-success';
      case "Rejected":
        return 'badge badge-danger';
        case "Closed":
          return 'badge badge-success';
          case "Cancelled":
            return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }}

    downloadExcel() 
    {

    }

    async open(data: PendingExitApprovalModel) 
    {
      this.MyPendingExitRequestApprovals = data.approvals;
     this.ExitRequest =data.exitClearance;
      this.ViewExitRequestVisible = true;
   
  
    }
    async openapproval(data: PendingExitApprovalModel)
    {

      let resRequests = await this.exitClearanceService.GetExitClearanceApprovalByClearance(data.exitClearance.id).toPromise();
      this.ExitRequestApprovals = <ExitClearanceApprovalDto[]>resRequests.responseData;

      this.isPendingpprovalModalVisible = true;
    }
    async loadRecords() {
      ;
      this.currentUser = this.tokenService.getInfo(); 
      this.email = this.currentUser.profile.email; 
      let resRequests = await this.exitClearanceService.getExitClearanceForms().toPromise();
      this.Requests = <PendingExitApprovalModel[]>resRequests.responseData;
    
    }
    async handleSubmit() {


    }

    close(): void {
      this.ViewExitRequestVisible = false;
      this.canPrint = false;
      
    }

    retractApprovalBtn(id: number){
      this.selectedId = id;
      this.isRetractModalVisible = true;
    }

     handleRetractCancel() {
      this.isRetractModalVisible = false;
      this.retractReason = '';
      this.selectedId = 0;
    }

  submitRetractReason() {
    if (!this.retractReason.trim()) {
      // Optional: show notification here
      // alert('Please enter a reason for retraction.');
       this.notification.sendMessage({
                  message:'Please enter a reason for retraction.',
                  type: NotificationType.info
                });
      return;
    }

    console.log('Retracting approval:', this.selectedId);
    console.log('Reason:', this.retractReason);

    const request = {
      id: this.selectedId,
      message: this.retractReason
    }

    // console.log('request:', request);

    this.exitClearanceService.UnApprove(request).subscribe(
      (response) => {
        if(response.requestSuccessful){
          this.notification.sendMessage({
                  message: response.message,
                  type: NotificationType.success
                });
                this.isRetractModalVisible = false;
                this.isPendingpprovalModalVisible = false;
                this.loadRecords();
        }else{
           this.notification.sendMessage({
                  message: response.message,
                  type: NotificationType.error
                });
        } 
      }, (err) => {
        this.notification.sendMessage({
                  message: err.error.message,
                  type: NotificationType.error
                });
      }
    )

    this.handleRetractCancel();
  }

    print(requestReference:EmployeeExitClearanceDto, templateId:string) {
     // this.documentService.DownloadPDF(templateId, `Movement Request - ${requestReference}`);
    }

    async approveRequest(ExitClearanceApproval: ExitClearanceApprovalDto  ) {
      // this.isManPowerpprovalModalVisible = true;
         ; 
         const model: approveMovementVm = { id: ExitClearanceApproval.id,  message: "Approved" };
         
          this.exitClearanceService.approve(model).subscribe({
            next: (data => {
              
              if (data.responseCode == "00") {
                this.notification.sendMessage({
                  message: data.message,
                  type: NotificationType.success
                });
   
                this.loadRecords();
                this.close()
              }
              else {
   
                this.notification.sendMessage({
                message: data.message,
                  type: NotificationType.error
                });
   
              }
   
            }),
            error: ((error: any) => {
              console.log(error.error);
              ;
   
   
              this.notification.sendMessage({
                message: error.error.message,
                type: NotificationType.error
              });
            })
   
          });
   
     }

}
